import { decode } from "jsonwebtoken";
import { identify, init } from "logrocket";
import EXOResponse from "../ajax/exo-response";
import { getApiV2Url } from "../core/core";

init("1anscj/ex-online-test", {
    dom: {
        baseHref: "https://cloud.ex-online.com/",
    },
    release: "20190919",
});

const userToken = window.localStorage.getItem("token");
$.ajax({
    type: "POST",
    url: getApiV2Url("User", "Info"),
    beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", "Bearer " + userToken);
        xhr.setRequestHeader("Exo-Pid", sessionStorage.getItem("pid"));
    },
    success(res) {
        const response = new EXOResponse(res);
        const claims = decode(userToken);
        const uuid: string = response.getData("id");
        // @ts-ignore
        const email: string = claims["http://claims.ex-online.com/email"];
        identify(uuid, {
            email
        });
    }
});
